/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryMoveEntryRequest
 */
export interface RevisdomAPIViewModelsEntryMoveEntryRequest {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryRequest
     */
    sourceId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryRequest
     */
    sourceEntryType?: RevisdomAPIViewModelsEntryMoveEntryRequestSourceEntryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryRequest
     */
    targetProjectId?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryRequest
     */
    targetParentId?: number | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryMoveEntryRequestSourceEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryMoveEntryRequestSourceEntryTypeEnum = typeof RevisdomAPIViewModelsEntryMoveEntryRequestSourceEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryMoveEntryRequestSourceEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryMoveEntryRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryMoveEntryRequest(value: object): value is RevisdomAPIViewModelsEntryMoveEntryRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryMoveEntryRequestFromJSON(json: any): RevisdomAPIViewModelsEntryMoveEntryRequest {
    return RevisdomAPIViewModelsEntryMoveEntryRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryMoveEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryMoveEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'sourceEntryType': json['sourceEntryType'] == null ? undefined : json['sourceEntryType'],
        'targetProjectId': json['targetProjectId'] == null ? undefined : json['targetProjectId'],
        'targetParentId': json['targetParentId'] == null ? undefined : json['targetParentId'],
    };
}

export function RevisdomAPIViewModelsEntryMoveEntryRequestToJSON(json: any): RevisdomAPIViewModelsEntryMoveEntryRequest {
    return RevisdomAPIViewModelsEntryMoveEntryRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryMoveEntryRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryMoveEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceId': value['sourceId'],
        'sourceEntryType': value['sourceEntryType'],
        'targetProjectId': value['targetProjectId'],
        'targetParentId': value['targetParentId'],
    };
}

